import React, { FC } from 'react';
import { useClassNameBuilderFactory } from '../../../../common/providers/ReactKitProvider';
import { Container } from '../Container/Container';

export interface ILoaderProps {
	animation?: 'border' | 'grow';
	centered?: boolean;
	childSpace?: boolean;
	count?: number;
	message?: string;
	simple?: boolean;
	size?: 'sm' | any;
}

// Custom Spinner component to replace Bootstrap Spinner
const Spinner: FC<{
	animation: 'border' | 'grow';
	size?: 'sm' | any;
	className?: string;
}> = ({ animation, size, className = '' }) => {
	const sizeClasses = size === 'sm' ? 'w-4 h-4' : 'w-8 h-8';
	
	if (animation === 'grow') {
		return (
			<div 
				className={`${sizeClasses} rounded-full bg-blue-500 animate-pulse ${className}`}
				role="status"
				aria-label="Loading"
			>
				<span className="sr-only">Loading...</span>
			</div>
		);
	}
	
	// Default border animation
	return (
		<div 
			className={`${sizeClasses} border-2 border-gray-200 border-t-blue-500 rounded-full animate-spin ${className}`}
			role="status"
			aria-label="Loading"
		>
			<span className="sr-only">Loading...</span>
		</div>
	);
};

const Loader: FC<ILoaderProps> = ({
	animation = 'border',
	centered = false,
	childSpace,
	count = 1,
	message,
	simple,
	size,
}) => {
	const classNames = useClassNameBuilderFactory()
		.Create()
		.AddConditionalClass(centered && !simple, 'flex flex-col items-center justify-center min-h-32 p-4')
		.AddConditionalClass(!centered && !simple, 'flex flex-col items-start p-4')
		.AddConditionalClass(simple, 'inline-flex items-center')
		.GetClassNames();

	const getSpinners = () => {
		const spinnerArr = [];
		for (let i = 0; i < count; i++) {
			spinnerArr.push(
				<Spinner 
					key={`spinner-${i}`} 
					animation={animation} 
					size={size}
					className={count > 1 && i > 0 ? 'ml-2' : ''}
				/>
			);
		}
		return spinnerArr;
	};

	return (
		<div className={classNames}>
			<Container childSpace={childSpace} horizontal>
				{getSpinners()}
			</Container>
			{message && (
				<label className={`${simple ? 'ml-2' : 'mt-2'} text-gray-600 text-sm`}>
					{message}
				</label>
			)}
		</div>
	);
};

export default Loader;
// import './Loader.scss';
// import styles from './Loader.module.scss';
// import React, { FC } from 'react';
// import { Spinner } from 'react-bootstrap';
// import { useClassNameBuilderFactory } from '../../../../common/providers/ReactKitProvider';
// import { Container } from '../Container/Container';

// export interface ILoaderProps {
// 	animation?: 'border' | 'grow';
// 	centered?: boolean;
// 	childSpace?: boolean;
// 	count?: number;
// 	message?: string;
// 	simple?: boolean;
// 	size?: 'sm' | any;
// }

// const Loader: FC<ILoaderProps> = ({
// 	animation = 'border',
// 	centered = false,
// 	childSpace,
// 	count = 1,
// 	message,
// 	simple,
// 	size,
// }) => {
// 	const classNames = useClassNameBuilderFactory()
// 		.Create()
// 		.AddConditionalClass(centered && !simple, styles.loader_container_centered)
// 		.AddConditionalClass(!centered && !simple, styles.loader_container)
// 		.AddConditionalClass(simple, styles.simple)
// 		.GetClassNames();

// 	const getSpinners = () => {
// 		const spinnerArr = [];
// 		for (let i = 0; i < count; i++) {
// 			spinnerArr.push(<Spinner key={`spinner-${i}`} animation={animation} role={'status'} size={size}></Spinner>);
// 		}
// 		return spinnerArr;
// 	};

// 	return (
// 		<div className={classNames}>
// 			<Container childSpace={childSpace} horizontal>
// 				{getSpinners()}
// 			</Container>
// 			<label>{message}</label>
// 		</div>
// 	);
// };

// export default Loader;
